<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path d="M12.3778 4H10.7778V20H12.3778V4Z" :class="colorClass" />
    <path d="M19.7778 11.2H3.77783V12.8H19.7778V11.2Z" :class="colorClass" />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
